import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 57vw;
  margin-top: 2.8vh;
  margin-left: 1.5vw;
  margin-right: 1vw;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.8vh;
  margin-left: 0.1vw;
  margin-right: 0.1vw;

  .active {
    background-color: #0090d3;
  }
`

export const ProgressBarCircle = styled.div`
  width: 1vw;
  height: 1vw;
  border-radius: 2vw;
  background-color: #c4c4c4;
`

export const ProgressBarLine = styled.div`
  width: 27vw;
  height: 0.5vh;
  background-color: #c4c4c4;
`

export const Phrase = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  line-height: 18.46px;
  color: #777777;
  padding: 0px 10px 10px 10px;
  margin-left: 0.6vw;

  li {
    margin-left: 10px;
  }
`

export const FileInput = styled.input`
  display: none;
`

export const ProgressDiv = styled.div`
  display: flex;
  position: relative;
  left: 50%;
  transform: translate(-50%, 0);
  margin: 0 0 12px 0;
  border: 1px #777 solid;
  height: 35px;
  border-radius: 4px;
  padding: 0;

  width: 300px;

  // @media (min-width: 1600px) {
  //     width: 350px;
  // }

  // @media (max-width: 1600px) {
  //     width: 300px;
  // }

  // @media (max-width: 1366px) {
  //     width: 250px;
  // }

  // @media (max-width: 1200px) {
  //     width: 200px;
  // }
`

export const ProgressContainer = styled.div`
  margin-top: 0.6vh;
  width: 13vw;
  height: 4px;
  background-color: #696969;
`

export const ProgressFill = styled.div`
  height: 4px;
  background-color: #6ec1e4;
`
export const LoadingMessage = styled.p`
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: 'Inter', sans-serif;
  margin-bottom: 0;

  img {
    width: 18px;
    margin-left: 10px;
  }
`

export const FileInputDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 56vw;
  margin-top: 1vh;
  margin-left: 1.6vw;
  border: dashed #33a6dc 2px;
  border-radius: 0.5vw;
  background-color: #e6f4fb;
`

export const FileInputLabel = styled.label`
  margin-left: 24.5vw;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1vw;
  max-width: 7.2vw;
  margin-top: 2vh;
  padding-top: 1.5vh;
  padding-right: 1.5vw;
  padding-bottom: 1.5vh;
  padding-left: 1.5vw;
  background-color: #fff;
  color: #0090d3;
  border: 1px solid #0090d3;
  border-radius: 1.5vw;
  cursor: pointer;
`

export const FileInfoDiv = styled.div`
  display: flex;
  margin-top: 1vh;
  margin-left: 21.5vw;
  width: 18vw;
  min-height: 5vh;
  border: 1px solid #000;
`

export const FileInfoImg = styled.img`
  width: 2vw;
  margin-left: 0.2vw;
`

export const FileMiddleDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.9vh;
  margin-left: 0.2vw;
  width: 13.2vw;
`

export const FileUpperMiddleDiv = styled.div`
  display: flex;
  max-height: 2vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 13.2vw;
  justify-content: space-between;
`

export const FileName = styled.p`
  display: block;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 0.8vw;
  max-width: 10.9vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'Inter', sans-serif;
`

export const FilePercentage = styled.p`
  position: relative;
  top: 0.1vh;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 0.8vw;
  font-family: 'Inter', sans-serif;
`

export const FileInfoCancelImg = styled.img`
  margin-left: 0.4vw;
  width: 1.6vw;
`

export const FileFirstText = styled.p`
  font-size: 1.2vw;
  margin-left: 20vw;
  margin-top: 2vh;
  margin-bottom: 0;
  font-family: 'Inter', sans-serif;
`

export const FileSecondText = styled.p`
  color: #696969;
  font-size: 1vw;
  margin-left: 18.8vw;
  margin-top: 0.5vh;
  margin-bottom: 2vh;
  font-family: 'Inter', sans-serif;
`

export const ButtonsDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-left: 41.5vw;
`

export const CancelButton = styled.button`
  width: 8vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  border: 1px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;
`

export const NextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #0090d3;
  color: #fff;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: pointer;
  // pointer-events: none;
`

export const NextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const NextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const DisabledNextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: not-allowed;
`

export const DisabledNextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const DisabledNextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`
